import styled from '@emotion/styled'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  items: ItemProps[]
  variant?: Variant
}

export const ZigZag = memo(function ZigZag({
  items,
  variant = 'default',
}: Props) {
  if (!items || items.length < 1) {
    return null
  }

  const item: any = items

  return (
    <Container>
      {variant === 'default' ? (
        items.map((item, index) => <Item key={index} {...item} />)
      ) : (
        <Item {...item} />
      )}
    </Container>
  )
})

const Container = styled.section`
  margin-top: 11.25rem;
  padding: 0 9.444vw;

  @media (max-width: 1199px) {
    margin-top: 5.25rem;
    padding: 0 2rem;
  }
`

export type Variant = 'default' | 'split'
